import { formatCurrency } from "@/common/utils/formatters"
import React from "react"
import EstablishmentFeeName from "../components/EstablishmentFeeName"
import EstablishmentFeeProduct from "../components/EstablishmentFeeProduct"
import { EstablishmentEvent } from "../types/establishmentEventData.type"
import { transformToNumber } from "@/common/utils/transformers"

export class EstablishmentFeeTransformer {
  static tableTransformer() {
    return (fees?: EstablishmentEvent[]) => {
      return fees?.map((fee) => {
        const totalFee = transformToNumber({ value: fee.amount, invert: true })
        return {
          name: fee.fee_source.fee_template.display_name
            ? React.createElement(EstablishmentFeeName, { name: fee.fee_source.fee_template.display_name })
            : '',
          product: fee.source.display_name
            ? React.createElement(EstablishmentFeeProduct, { product: fee.source.display_name })
            : '',
          amount: (
            <p className={totalFee > 0 ? 'text-valid' : totalFee < 0 ? 'text-danger-soft' : ''}>
              {formatCurrency(totalFee)}
            </p>
          ),
        }
      })
    }
  }
}
